export default __webpack_public_path__ + "static/media/eiderdown.d61781af.svg";